module.exports = __webpack_public_path__ + "img/2.8bc9d8b7.jpg";